import { render, staticRenderFns } from "./PoiAdd.vue?vue&type=template&id=50061cb5&scoped=true&"
import script from "./PoiAdd.vue?vue&type=script&lang=js&"
export * from "./PoiAdd.vue?vue&type=script&lang=js&"
import style0 from "./PoiAdd.vue?vue&type=style&index=0&id=50061cb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50061cb5",
  null
  
)

export default component.exports